import { Checkbox, Col } from '@op/opds.opux';
import React , { useState } from 'react';
import { Message, useMessageGetter } from '@messageformat/react';
import {
  IO_ADD_INSURANCE_TARGET,
  IO_DELETE_ALL_INSURANCES
} from '../../constants/actionTypes';
import { DEFAULT_LOCALE } from '../../constants/common';
import { useInsuranceOffer } from '../../hooks';

const InsuranceTile = ({ tile, name }) => {
  const getMessage = useMessageGetter();
  const getDefaultMessage = useMessageGetter([], { locale: DEFAULT_LOCALE });
  const [checked, setChecked] = useState(tile.count > 0);

  const { state, createOrDeleteInsurance } = useInsuranceOffer();

  const addInsuranceTarget = (
    insuranceId,
    component,
    validator,
    icon,
    title
  ) => {
    const insuranceSelectionIndex = state.insuranceSelectionIndex;
      
      createOrDeleteInsurance({
      type: IO_ADD_INSURANCE_TARGET,
      insuranceId,
      insuranceSelectionIndex,
      component,
      validator,
      icon,
      caption: getMessage(title),
      defaultCaption: getDefaultMessage(title),
      sendInsurance: true
    });
    setChecked(true);
  };

  const deleteAllInsurances = (insuranceId) => {
    createOrDeleteInsurance({
      type: IO_DELETE_ALL_INSURANCES,
      insuranceId,
    });
    setChecked(false);
  };

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    if(isChecked){
      addInsuranceTarget(
        tile.insuranceId,
        tile.component,
        tile.validator,
        tile.icon,
        `uiText.${tile.insuranceId}`
      );     
    }else{
      deleteAllInsurances(tile.insuranceId);
    }
  }

  return (
    <Col xs={8} lg={4}>
        <div className="insurance-tile-div">
          <div className="insurance-tile-button">
            <tile.icon
                viewBox={'-15 -15 100 100'}
                className={`RS-insurance-selection-icon`}
            />
            {tile.count ? (
                <Checkbox
                  checked={checked}
                  onChange={handleCheckboxChange}
                  id={`checkbox-${name}`}
                  type="checkbox"
                >
                  <div className="insuranceselector-name-text">           
                    <span className={'RS-insurance-selection-header'}>
                      <Message id={`uiText.${tile.insuranceId}`} />
                    </span>
                  </div>
                </Checkbox>
             ) : (
                <Checkbox
                  onChange={handleCheckboxChange}
                  id={`checkbox-${name}`}
                  type="checkbox"
                >
                  <div className="insuranceselector-name-text">           
                    <span className={'RS-insurance-selection-header'}>
                      <Message id={`uiText.${tile.insuranceId}`} />
                    </span>
                  </div>
                </Checkbox>
            )}
          </div>                
        </div>       
    </Col>
  );
};

export default InsuranceTile;
